
/////////////////////////////////////////////////////////////////////////
// StateMachine //////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const StateMachine = {
	
  init: function() {

    this.state = null;
    this.states = {};
    this.stack = [];

    return this;
  },

  createState: function(stateObject, game) {

    var newState = Object.create(stateObject);
    newState.setup(game);

    return newState;
  },

  getCurrentState: function() {
    return this.state;
  },
  
  bindState: function(id, state) {
    this.states[id] = state;
  },
  
  switchState: function(id) {

    var newState = this.states[id];
    
    if (newState === null) {
      throw new Error('ID ' + id + ' is unbound, cannot change states.');
    }
    
    var aNumStates = this.stack.length;
    for (var i = (aNumStates - 1); i >= 0; i--) {
      var state = this.stack[i];
      state.onExit();
    }
    
    this.stack.length = 0;
    this.stack.push(newState);
    
    this.state = newState;
    newState.onEnter();
  },
  
  pushState: function(id) {
    
    var newState = this.states[id];
    
    if (newState === null) {
      throw new Error('ID ' + id + ' is unbound, cannot change states.');
    }
    
    if (this.stack.length > 0) {
      var oldState = this.stack[this.stack.length - 1];
      oldState.onPush();
    }
    
    this.stack.push(newState);
    this.state = newState;
    newState.onEnter();
  },
  
  popState: function() {
    
    if (this.stack.length === 0) {
      return;
    }
    
    var oldState = this.stack.pop();
    oldState.onExit();
    
    if (this.stack.length > 0) {
      var newState = this.stack[this.stack.length - 1];
      this.state = newState;
      newState.onPop();
    }
  }

};

export default StateMachine;



		




// WEBPACK FOOTER //
// ./app/src/utils/statemachine/StateMachine.js